import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import {inject} from 'mobx-react';
import WritingYes from '../component/WritingYes';
import PlotYes from '../component/PlotYes';
import FormationYes from '../component/FormationYes';


@withRouter
@inject("store")

export default class Improve extends Component
{

    back(){
        this.props.store.upsetwith = "nothing";
        this.forceUpdate();
    }

    writing(){
        this.props.store.upsetwith = "writing";
        this.forceUpdate();
    }

    writingyes(){
        this.props.store.upsetwith = "writingyes";
        this.forceUpdate();
        this.props.store.writingyes= "nothing";
    }


    plot(){
        this.props.store.upsetwith = "plot";
        this.forceUpdate();

    }

    plotyes(){
        this.props.store.upsetwith = "plotyes";
        this.forceUpdate();
        this.props.store.plotyes= "nothing";

    }

   

    formation(){
        this.props.store.upsetwith = "formation";
        this.forceUpdate();

    }

    formationyes(){
        this.props.store.upsetwith = "formationyes";
        this.forceUpdate();
        this.props.store.formationyes= "nothing";
    }

    story(){
        this.props.store.upsetwith = "nothing";
        this.forceUpdate();
        this.props.history.push("/story");
    }

    render()
    {
        return <div className = "improve">
              <img src={cookie} className="cookiepicture" alt="cookie" />
              <br/>
             
              {this.props.store.upsetwith == "nothing"?<> 
              <div className = "improvetext">是哪方面不满意呢？</div>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.writing() } >对文笔不满意</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.plot() }>对情节不满意</Button><br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.formation() } >对结构不满意</Button><br/>
              <br/>
              <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.story() } >其实我还没写过故事</Button><br/>
              </>
            :
            <>
               {this.props.store.upsetwith == "writing" && <div className = "asktext">
                   你是对自己的文笔不满意吗？<br/><br/>
                   如果是，你可能会嫌弃自己的文字不够生动，不够清晰，没有感染力<br/><br/>
                   写的时候觉得词穷，写出来又觉得生硬，尴尬<br/><br/>
                   想描述自己脑海中的场景，服饰或动作，却怎么也写不出来<br/><br/>
                   看到别人华丽的辞藻，炫酷的描写，一段又一段的诗词引用会觉得难过和自卑<br/>
                   因为自己差距太远了<br/><br/>
                   所以你是对自己的文笔不满意吗？<br/>
                   
                   <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.writingyes() } >就是它了！</Button><br/>
                   <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.back() } >不是，是其他的</Button><br/>
                   </div>}

                   {this.props.store.upsetwith == "writingyes" && <WritingYes/>}

                   {this.props.store.upsetwith == "plot" && <div className = "asktext">
                   你是对自己写出来的情节不满意吗？<br/>
                   明明脑海中是个波澜壮阔，跌宕起伏的故事<br/>
                   但是写出来却平平淡淡，像是流水账一样<br/>
                   即使描写很华丽，很壮观，很出彩，看着也依旧很简单又无趣<br/>
                   经常抓破脑袋，也想不出有趣的情节来<br/><br/>
                   很多文笔不怎么样的小说，也能让大家看得津津有味<br/>
                   希望自己也能做到这一点<br/><br/>
                   所以你是对自己的情节不满意吗？<br/>
                   <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.plotyes() } >就是它了！</Button><br/>
                   <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.back() } >不是，是其他的</Button><br/>
                       </div>}

                    {this.props.store.upsetwith == "plotyes" && <PlotYes/>}

                    {this.props.store.upsetwith == "formation" && <div className = "asktext">
                    你是对自己小说的结构不满意吗？<br/><br/>
                    如果是的话，你会觉得小说写得很散乱<br/>
                    东写一点，西写一点，乱七八糟的，好像想到哪就写到哪<br/>
                    经常写着写着，不知道之后要写点什么<br/>
                    前后写的事，好像没什么关系，更别提伏笔什么的了<br/><br/>
                    想要写出更完整，更有条理的大故事来<br/><br/>
                    所以你是对自己的情节不满意吗？<br/>
                   <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.formationyes() } >就是它了！</Button><br/>
                   <Button icon="arrow-right" className="Button" minimal={true}  onClick={()=>this.back() } >不是，是其他的</Button><br/>
                        </div>}

                        {this.props.store.upsetwith == "formationyes" && <FormationYes/>}
            
            </>}
            
             



        </div>;
    }
} 